import script from "./WhoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoPage.vue?vue&type=script&setup=true&lang=js"

import "./WhoPage.vue?vue&type=style&index=0&id=5eb92bd3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb92bd3"]])

export default __exports__